// CarStockImporter.js
import { ACCESS } from "constants/accessPermissions"
import { useAuth } from "hooks/authHook"

// Accept optional hasAnyPermission function for non-React usage
export const getCarStockImporterText = (car = {}, hasPermissionFn) => {
  const canAccess = hasPermissionFn
    ? hasPermissionFn([ACCESS.VEHICLE_IMPORTER.VIEW_VEHICLE_IMPORTER])
    : false

  return canAccess
    ? `${car.full_chassis ?? "N/A"}\n${car.importer ? `(${car.importer})` : ""}`
    : car.full_chassis ?? "N/A"
}

// Default React component wrapper
const CarStockImporter = ({ car = {} }) => {
  const { hasAnyPermission } = useAuth()
  return getCarStockImporterText(car, hasAnyPermission)
}

export default CarStockImporter
